module.exports = __webpack_public_path__ + "img/train3.84c63f9b.gif";